import { configureStore } from '@reduxjs/toolkit';
import registerReducer from './slices/register';
import surveyReducer from './slices/survey';

export const store = configureStore({
  reducer: {
    register: registerReducer,
    survey: surveyReducer,
  },
});
